import Repository from '@/repositories/Repository'
import { Present } from '@/models/Present'

export type PresentParams = {
  stationList: {
    stationId: string
    target: string[]
  }[]
}

export type PresentApiResponse = {
  items: Present[]
  time: string
}

class PresentRepository extends Repository {
  constructor() {
    super('/current')
  }

  async get(params: PresentParams): Promise<PresentApiResponse> {
    const data = await super._post<PresentParams>(params)

    return data as PresentApiResponse
  }
}

export default PresentRepository
